module.exports = __webpack_public_path__ + "prod/20260903163609/img/logo_v2.a0a47605.png";